const webPatientsBaseUrl = () => process.env.NEXT_PUBLIC_BASE_URL;

export const clientRoutes = {
  corporateLanding: (name: string) => `/corporate-membership/${name}`,
  patients: () => "/patients",
  doctorsWithCity: (city: string) => `/doctors/doctors-in-${city}-dcity`,
  hospitalsInIndia: () => "/hospitals-and-clinics",
  hospitalsInIndiaWithQuery: (querySearch?: string) =>
    `/hospitals-and-clinics${querySearch}`,
  hospitalsWithCity: (city: string, queryparams?: string) =>
    `/hospitals-and-clinics/${city}${queryparams}`,
  hospitalDetailPage: (
    hospitalType: string,
    hospital: string,
    id: string,
    city: string
  ) => `/${hospitalType}/${hospital}-in-${city}-${id}`,
  specialtyDetailsWithCity: (specialty: string, city: string) =>
    `/doctors/${specialty}-in-${city}-scity`,
  specialtyDetailsNearMe: (specialty: string) =>
    `/doctors/${specialty}-near-me`,
  welcome: () => "/",
  doctorDetails: (doctorName: string, doctorId: string) =>
    `/doctors/${doctorName}-${doctorId}`,
  specialityDetails: (specialty: string) => `/specialties/${specialty}`,
  specialtyDoctorDetails: (
    specialty: string,
    doctorName: string,
    doctorId: string
  ) => `/specialties/${specialty}/${doctorName}-${doctorId}`,
  symptomsDoctors: () => "/track-symptoms/doctors",
  specialties: (specialty: string) => `/specialties/${specialty}`,
  citySpecialties: (city: string, specialty: string) =>
    `/${city}/specialties/${specialty}`,

  appointments: () => "/appointments",
  appointmentSuccess: () => `/appointments/${status}`,
  testsAndMedicine: () => "/tests-medicines",
  medicines: () => process.env.NEXT_PUBLIC_PHARMACY_FRONTEND_URL,
  medicineSearch: () => `/medicine-search`,
  medicinesLandingViewCart: () => `/medicines/added-to-cart`,
  medicinesCartInfo: (orderAutoId: string, orderStatus: string) =>
    `/medicines/${orderAutoId}/${orderStatus}`,
  healthRecords: (recordType: string) => {
    if (recordType === "") {
      return "/health-records";
    }
    return `/health-records/${recordType}`;
  },
  // healthRecords: () => `/health-records`,
  prescriptionsLanding: () => "/prescriptions",
  cartLanding: () => "/cart",
  medicinesCart: () => "/medicines-cart",
  medicinesCartFailed: (orderAutoId: string, orderStatus: string) =>
    `/medicines-cart/${orderAutoId}/${orderStatus}`,
  testsCart: () => "/tests-cart",
  chatRoom: (appointmentId: string, doctorId: string) =>
    `/chat-room/${appointmentId}/${doctorId}`,
  myAccount: () => "/my-account",
  notificationSettings: () => "/settings",
  addHealthRecords: (type: string) => `/add-record/${type}`,
  yourOrders: () => "/orders",
  medicineAllBrands: () => "/medicine/brands",
  medicineSearchByBrand: (id: string) => `/search-by-brand/${id}`,
  searchByMedicine: (searchMedicineType: string, searchText: string) =>
    `/medicine/${searchMedicineType}/${searchText}`,
  medicineDetails: (sku: string) => `/medicine/${sku}`,
  medicineCategoryDetails: (
    searchMedicineType: string,
    searchText: string,
    sku: string
  ) => `/medicine/${searchMedicineType}/${searchText}/${sku}`,
  addressBook: () => "/address-book",
  symptomsTrackerFor: () => "/track-symptoms-for",
  symptomsTracker: () => "/track-symptoms",
  tests: () => "/lab-tests",
  testsWithCartOpen: () => "/lab-tests?open_cart=true",
  testDetailsByItemId: (itemId: string) => `/test-details/${itemId}`,
  testDetailsWithCity: (cTag: string, city: string, source?: string) =>
    `/lab-tests/${cTag}/${city}${source?.length ? `?source=${source}` : ""}`,
  testDetails: (cTag: string, source?: string) =>
    `/lab-tests/${cTag}${source?.length ? `?source=${source}` : ""}`,
  searchByTest: (searchTestText: string) => `/search-test/${searchTestText}`,
  testOrders: () => "/order-details",
  orderSummary: (id: string) => `/orders/order-summary/${id}`,
  termsConditions: () => "/terms",
  privacy: () => "/privacy",
  FAQ: () => "/faq",
  partnerSBI: () => "/partners/sbi",
  contactUs: () => "/contact",
  blogLanding: () => "/blog",
  searchedArticlesList: (searchedText: string) => `/blog?s=${searchedText}`,
  kavachLanding: () => "/covid19/kavach",
  covidCareLanding: () => "/covid19/covid-care",
  covidDetails: () => "/covid19/*",
  articleDetails: () => "/blog/*",
  aboutUs: () => "/aboutUs",
  needHelp: () => "/needHelp",
  myPayments: () => "/my-payments",
  payMedicine: (payType: string) => `/pay/${payType}`,
  payOnlineConsult: () => "/pay-online-consult",
  payOnlineClinicConsult: () => "/pay-clinic-visit",
  prescriptionReview: () => "/prescription-review",
  specialityListing: () => "/specialties",
  medicinePrescription: () => "/medicine-prescription",
  covidDiabetes: () => "/medical-condition/covid-and-diabetes",
  partnersHdfc: () => "/partners/hdfc",
  membershipHdfc: () => "/partners/hdfc-membership",
  myMembership: () => "/my-membership",
  careFirstMembership: () => "/membership/care-first",
  careFirst: () => "/landing/care-first",
  membershipPlanLocked: () => "/partners/hdfc-membership-locked",
  membershipPlanDetail: () => "/partners/hdfc-membership-plan-detail",
  covidProtocol: () => "/medical-condition",
  dietetics: () => "specialties/dietetics",
  prescription: (appointmentId: string) => `/prescription/${appointmentId}`,
  sitemap: (sitemap: string) => `/static/${sitemap}`,
  childSitemap: (sitemap: string, pageNo: string) =>
    `/static/${sitemap}/${pageNo}`,
  oneApolloMembership: () => "/oneapollo-membership",
  apolloProHealthCategories: (source?: string, lat?: number, lng?: number) => {
    const baseUrl = "/apollo-prohealth";

    const queryParams: string[] = [];
    if (source?.length) {
      queryParams.push(`source=${source}`);
    }
    if (lat !== undefined && !Number.isNaN(lat)) {
      queryParams.push(`lat=${lat}`);
    }
    if (lng !== undefined && !Number.isNaN(lng)) {
      queryParams.push(`lng=${lng}`);
    }

    const finalUrl = queryParams?.length
      ? `${baseUrl}?${queryParams.join("&")}`
      : baseUrl;

    return finalUrl;
  },
  apolloProHealthLanding: () => "/apollo-pro-health",
  apolloProHealthAppointments: () => `/apollo-prohealth-appointments`,
  proHealthOrderDetail: (id: string) => `/apollo-prohealth-appointments/${id}`,
  apolloProHealthSuccess: (displayId: string | number) =>
    `/apollo-prohealth-success/${displayId}`,
  apolloProHealthDetails: (
    cityName: string,
    hospitalName: string,
    categoryName: string
  ) => `/apollo-prohealth-details/${cityName}/${hospitalName}/${categoryName}`,
  pageNotFound: () => "/page-not-found",
  corporatePromo: (corporateName: string) => `/corporate/${corporateName}`,
  careLanding: () => "/landing/circle",
  pharmaLanding: () => "/pharma-landing",
  consultLanding: () => "/consult-landing",
  OrderSucceedConsult: () => "/consult/ordersuccess",
  testsCircleLanding: () => "/test-landing",
  careMembership: () => "/membership/circle",
  payCare: () => "/pay-care",
  subscriptions: () => "/subscriptions",
  orderSucceedTest: () => "/order-succeed-test",
  orders: () => "/orders",
  previousOrders: () => "/previous-orders",
  uploadPrescription: () => "/upload-prescription",
  uploadPrescriptionSuccess: () => "/upload-prescription?success=true",
  healthQueries: () => "/health-queries",
  labTestsQueries: () => "/lab-tests-queries",
  subSpecialtyListing: (specialty: string) => `/health-queries/${specialty}`,
  subCategoryLabTestsListing: (labTestsCatgeory: string) =>
    `/lab-tests-queries/${labTestsCatgeory}`,
  subTestCategoryListing: (subCategory: string) =>
    `/lab-tests-queries/${subCategory}`,
  // sitemap: (sitemap: string) => `/${sitemap}`,
  // childSitemap: (sitemap: string, pageNo: string) => `/${sitemap}/${pageNo}`,
  storeLocator: () => "/medical-stores",
  storeDetails: (locality: string, city: string, storeId: string) =>
    `/medical-stores/apollo-pharmacy-${locality}-${city}-${storeId}`,
  storeLocatorWithCity: (city: string) =>
    `/medical-stores/apollo-pharmacies-in-${city}-stcity`,
  covidPage: (urlKey: string) => `/${urlKey}`,
  doctorsWithLocality: (city: string) => `/doctors/doctors-in-${city}-dloc`,
  specialtyDoctorsWithLocality: (specialty: string, city: string) =>
    `/doctors/${specialty}-in-${city}-sloc`,
  specialtyWithCity: (specialty: string, city: string) =>
    `/specialties/${specialty}-in-${city}-scity`,
  doctorsNearMePage: () => "/doctors/doctors-near-me",
  specialityPage: (specialty: string) => `/specialties/${specialty}`,
  specialtyWithLocality: (specialty: string, city: string) =>
    `/specialties/${specialty}-in-${city}-sloc`,
  orderStatusInfo: (transactionId: string, orderStatus: string) =>
    `/order-status/${transactionId}/${orderStatus}`,
  healthToolPage: () => "/blog/health-tools",
  medicinePageLanding: () =>
    " https://www.apollopharmacy.in/search-medicines/weight-management",
  appointmentConsultationGuideline: () => "/appointment-consultation-guideline",
  testListingCategory: (widgetTitle: string) =>
    `/lab-tests-category/${widgetTitle}`,
  testListing: (widgetTitle: string) => `/test-listing/${widgetTitle}`,
  categoryListing: (widgetTitle: string) => `/category-listing/${widgetTitle}`,
  selectPatients: () => `/selected-patients`,
  orderdetails: (itemId: string) => `/order-details/${itemId}`,
  resampleOrder: (orderId: string) => `/resample-order/${orderId}`,
  juspaySSR: (vertical: string, orderId: string) =>
    `/payments/${vertical}/${orderId}`,
  radiology: (source: string, keyword?: string): string =>
    `/lab-tests/radiology?source=${source}${
      keyword?.length ? `&keyword=${keyword}` : ""
    }`,
  oneTapSuccess: () => `/one-tap-success`,
  oneTapLanding: () => `/one-tap-online-doctor-consultation`,
  hospitalPagination: (sitemap: string, pageNo: string) =>
    sitemap.includes("-in")
      ? `/hospitals-and-clinics/${sitemap}?page=${pageNo}`
      : `/hospitals-and-clinics?page=${pageNo}`,
  hospitalPaginationWithHospitalTypeFilter: (
    pageNo: any,
    searchParams?: string
  ) =>
    searchParams.length > 1
      ? `/hospitals-and-clinics${searchParams}&page=${pageNo}`
      : `/hospitals-and-clinics?page=${pageNo}`,
  hospitalPaginationTypeWithCity: (
    pageNo: any,
    searchParams?: string,
    city?: string | string[]
  ) =>
    searchParams.length > 1 && city
      ? `/hospitals-and-clinics/${city}${searchParams}&page=${pageNo}`
      : searchParams.length === 0 && city === ""
      ? `/hospitals-and-clinics?page=${pageNo}`
      : searchParams.length === 0 && city
      ? `/hospitals-and-clinics/${city}?page=${pageNo}`
      : `/hospitals-and-clinics${searchParams}&page=${pageNo}`,
  symptomChecker: () => "/symptom-checker",
  diseaseDeatiledPages: (slug) => `/disease-and-conditions${slug}`,
  symptomCheckerSummary: () => "/symptom-checker-summary",
  symptomCheckerAppointment: () => "/symptom-checker-appointment",
  oneTapConsultLanding: () => `/one-tap-online-doctor-consultation`,
  diagnosticListing: (slug: string) => `/diagnostic-listing/${slug}`,
  refund: () => "/refund-policy",
  insuranceDetails: () => "/insurance-details",
  insurance: () => "/insurance",
};

export const clientBaseUrl = () => webPatientsBaseUrl();
